import { isValidObject } from "../../Services/validators";

export const defaultLiveFeedFilter = {
  PCTNo: [],
  ward: [],
  zone: []
};

export function getUniqueDataFromObj(value, data) {
  const result = [];
  
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const item = data?.[key];
      if (!result.includes(item?.location[value])) {
        result.push(item?.location[value]);
      }
    }
  }
  return result;
}

export const liveFeedFilterData = (devices) => [
  {
    key: "PCTNo",
    multiple: true,
    search: true,
    searchData: {
      label: "Search PCT / Address"
    },
    options: getLocationListFromDevices(devices),
    title: "LOCATIONS"
  },
  {
    key: "ward",
    multiple: true,
    search: true,
    searchData: {
      label: "Search Ward"
    },
    options: getUniqueDataFromObj("ward", devices)?.sort((a, b) =>
      a?.localeCompare(b)
    ),
    title: "WARD"
  },
  {
    key: "zone",
    multiple: true,
    options: getUniqueDataFromObj("zone", devices)?.sort(
      (a, b) => parseInt(a) - parseInt(b)
    ),
    title: "ZONE"
  },
];

export function getLocationListFromDevices(devices) {
  if (!isValidObject(devices)) {
    return [];
  }

  let locations = {}

  for (const key in devices) {
    if (devices.hasOwnProperty(key)) {
      const data = devices?.[key];

      if(locations[data.location?.id]){
        continue
      } else if(data.location?.id) {
        locations[data.location?.id] = data.location
      }
    }
  }

  return Object.values(locations)
    .sort((a, b) => {
      const nameA = parseInt(a?.PCTNo) || 0;
      const nameB = parseInt(b?.PCTNo) || 0;
      return nameA - nameB;
    })
    .map(( location ) => `${location.PCTNo || "N/A"} - ${location.address || "N/A"}`);
}